import React from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";

import { ReactComponent as ArrowRightLineIcon } from "../../../../../assets/images/product/specmanager/arrow-right-line.svg";
import { ReactComponent as DiscardIcon } from "../../../../../assets/images/product/specmanager/Discard.svg";
import "./DiscardChangesConfirmModal.css";

/**
 * Unsaved-changes / discard confirmation only (Test Spec Manager exit flows).
 * For save/add/update confirmations, use {@link ./ConfirmModal}.
 */
export default function DiscardChangesConfirmModal({
  headerText,
  bodyText,
  buttonText,
  buttonFunctions,
  disableConfirmButton,
  loadingConfirm,
}) {
  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      footer={null}
      width={520}
      wrapClassName="DiscardChangesConfirmModal"
      className="DiscardChangesConfirmModal"
    >
      <div className="DiscardChangesConfirmModal__root">
        <div className="DiscardChangesConfirmModal__column">
          <div className="DiscardChangesConfirmModal__iconBackdrop">
            <DiscardIcon className="DiscardChangesConfirmModal__icon" aria-hidden />
          </div>

          <div className="DiscardChangesConfirmModal__textStack">
            <h2 className="DiscardChangesConfirmModal__title">{headerText}</h2>
            <p className="DiscardChangesConfirmModal__body">
              {bodyText}
            </p>
          </div>
        </div>

        <div className="DiscardChangesConfirmModal__footer">
          <Button
            type="default"
            className="DiscardChangesConfirmModal__btn"
            onClick={buttonFunctions[0]}
            disabled={disableConfirmButton}
          >
            {buttonText[0]}
          </Button>
          <Button
            type="primary"
            className="DiscardChangesConfirmModal__btn"
            onClick={buttonFunctions[1]}
            disabled={disableConfirmButton}
            loading={loadingConfirm}
            icon={<ArrowRightLineIcon />}
          >
            {buttonText[1]}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
